/*
 * @Author: llzq
 * @Date: 2020-12-12 15:59:37
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 13:50:01
 * @Description:  头部注释
 */
import React from "react";
import {Spin} from "antd";
const PageLoading = (props) => (
  <div style={{ textAlign: "center", margin: "80px 0" }}>
    <Spin size="large" />
  </div>
);

export default PageLoading;
